import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserManagementComponent } from '../../features/admin/view/user-management/user-management.component';
import { CategoryManagementComponent } from '../../features/admin/view/category-management/category-management.component';
import { CompetitionManagementComponent } from '../../features/admin/view/competition-management/competition-management.component';
import { PriorityManagementComponent } from '../../features/admin/view/priority-management/priority-management.component';
import { OrchestratorDbManagementComponent } from '../../features/admin/view/orchestrator-db-management/orchestrator-db-management.component';
import { InternalVideoManagementComponent } from '../../features/admin/view/internal-video-management/internal-video-management.component';
import { WiseIdAuthServiceManager } from '../../features/sso-wise-id/controller/wise-id-auth.service-manager';
import { VideoLabService } from '../../features/video/controller/video-lab.service';

@Component({
  selector: 'app-admin-page',
  standalone: true,
  imports: [
    CommonModule,
    UserManagementComponent,
    CategoryManagementComponent,
    CompetitionManagementComponent,
    PriorityManagementComponent,
    OrchestratorDbManagementComponent,
    InternalVideoManagementComponent
  ],
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.scss']
})
export class AdminPageComponent implements OnInit {
  public activeTab: 'users' | 'categories' | 'competitions' | 'priority' | 'internalVideos' | 'orchestratorDb' = 'users';
  public readonly canManageOrchestratorDb: boolean;
  public canManageInternalVideos: boolean = false;

  constructor(
    private wiseIdAuthServiceManager: WiseIdAuthServiceManager,
    private videoLabService: VideoLabService
  ) {
    const userEmail = (this.wiseIdAuthServiceManager.getUserProfileSessionData()?.profile?.email || '').trim().toLowerCase();
    this.canManageOrchestratorDb = userEmail === 'acorcino@iasolver.com';
  }

  ngOnInit(): void {
    this.videoLabService.checkInternalAccess().subscribe({
      next: (hasAccess) => {
        this.canManageInternalVideos = hasAccess;
      },
      error: () => {
        this.canManageInternalVideos = false;
      }
    });
  }

  selectTab(tab: 'users' | 'categories' | 'competitions' | 'priority' | 'internalVideos' | 'orchestratorDb'): void {
    this.activeTab = tab;
  }
}
